import { IGeocodeJsonResponse } from "../types/IGeocodeAdresse";

export const autocompleteAddress = async (text: string) => {
  try {
    const urlEncodedText = encodeURIComponent(text);
    const response = await fetch(
      `https://api-adresse.data.gouv.fr/search/?autocomplete=1&q=${urlEncodedText}`
    );

    if (!response.ok) {
      throw new Error(
        `Error getting address geocode data: ${response.statusText}`
      );
    }

    const data: IGeocodeJsonResponse = await response.json();
    return data.features;
  } catch (error) {
    return Promise.reject(error);
  }
};